import { Injectable } from '@angular/core';

/**
 * Kullanıcının öteki türde (Şirket↔Üyelik) hesabı var mı. 125 için kullanıcı kararıyla sabit false:
 * satır çizilmez, yalnız "Yeni hesap aç" görünür. Kaynak kararı (örn. GET /v2/Org/Me) 125 sonrası gelince
 * yalnız bu sınıf değişir.
 */
@Injectable({ providedIn: 'root' })
export class OtherAccountSource {
    async hasOther(): Promise<boolean> {
        return false;
    }
}
